import React from 'react'
// libs
import { Helmet } from 'react-helmet-async'
import { useRouter } from 'hooks/useRouter'
// components
import NavigationSidebar from 'components/UI/NavigationSidebar'
import MainLayoutContainer from 'containers/MainLayout'
import { Button, BUTTON_LAYOUTS } from 'components/UI'
// view components
import ObjectDetails from './Details'
import ObjectSecurity from './Security'
import ReviewQuestions from './ReviewQuestions'
import ObjectProperties from 'containers/ObjectsAndProperties/Edit/ObjectProperties'
// context
import { ObjectsAPIContext } from 'containers/ObjectsAndProperties/Edit/layers/API'
// views
import { Container } from '@mui/material'
import { SettingsIcon } from 'themes/views/settings'
import { settingsSidebarConfig } from 'layouts/SettingsLayout/config'
import { SectionsContainer, Title } from './view'
import { LayoutContainerInnerWrapper } from 'themes/views/layouts'

const ObjectUpdate: React.FC = () => {
  const router = useRouter()

  const { object, loading } = React.useContext(ObjectsAPIContext)

  const shouldShowSecuritySection = object?.apiName === 'kpis' || object?.apiName === 'actions'

  const onBackClick = () => router.back()

  if (!object) {
    return null
  }

  return (
    <>
      <Helmet>
        <title>Skefto - Object Edit</title>
      </Helmet>
      <MainLayoutContainer
        isLoading={loading}
        CTA={
          <Button layout={BUTTON_LAYOUTS.PURPLE} onClick={onBackClick} type='button'>
            Back
          </Button>
        }
        label={
          <>
            <SettingsIcon />
            Object
          </>
        }>
        <NavigationSidebar config={settingsSidebarConfig} />
        <LayoutContainerInnerWrapper>
          <Container maxWidth={false}>
            <Title>{object.name}</Title>
            <SectionsContainer>
              <ObjectDetails />
              {shouldShowSecuritySection && <ObjectSecurity />}
              <ReviewQuestions />
              <ObjectProperties />
            </SectionsContainer>
          </Container>
        </LayoutContainerInnerWrapper>
      </MainLayoutContainer>
    </>
  )
}

export default ObjectUpdate
